"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResponsivePropValue = getResponsivePropValue;
exports.isBreakpointObject = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const isBreakpointObject = sizes => {
  // See https://medium.com/@derek_develops/using-object-prototype-tostring-call-to-check-for-a-number-in-javascript-5dfb33edb6c5
  return Object.prototype.toString.call(sizes) === '[object Object]';
};

/**
 * Returns the corresponding mapped value of a `ResponsiveProp<T>` object
 * @param selector (prop: TProp) => TValue
 */
exports.isBreakpointObject = isBreakpointObject;
function getResponsivePropValue(selector) {
  return prop => {
    if (Array.isArray(prop)) {
      return prop.map(selector);
    }
    if (isBreakpointObject(prop)) {
      const propKeys = Object.keys(prop);
      return propKeys.reduce((memo, key) => _objectSpread(_objectSpread({}, memo), {}, {
        [key]: selector(prop[key])
      }), {});
    }
    return selector(prop);
  };
}